<template>
  <v-modal v-if="isShown" x-short @close="handleClose">
    <template slot="#scheduled">
      <div class="text-center p-5">
        <v-icon icon="schedule" class="text-grey-60" size="3rem" />

        <h2 class="mb-2">Content Not Available Yet</h2>
        <p class="mt-0 lead">
          Available in <strong>{{ availableIn }}</strong>
        </p>
      </div>
    </template>
  </v-modal>
</template>

<script>
import { mapGetters } from "vuex"

import EventBus, { EVENTS } from "@/lib/event-bus"
import { isPresent } from "@/lib/utils"
import { timeAgo } from "@/lib/date-utils"

export default {
  data() {
    return {
      isShown: false,
      availableIn: null,
      pageTitle: ""
    }
  },

  methods: {
    handleClose() {
      this.$router.removeHash()
      this.isShown = false
    }
  },

  mounted() {
    EventBus.$on(EVENTS.TRIGGER_SCHEDULED_MODAL, pageId => {
      if (!isPresent(pageId)) return

      const access = this.getPageAccess(pageId)

      if (
        isPresent(access) &&
        isPresent(access.data) &&
        isPresent(access.data.available_after)
      ) {
        this.isShown = true
        this.$router.push("#scheduled")
        this.availableIn = timeAgo(access.data.available_after, true)
      }
    })
  },

  computed: {
    ...mapGetters("pages", ["getPageAccess"])
  }
}
</script>
